<template>

    <div class="crm-main-cont">
        <div class="search-box">
            <a-form :form="formSearch">
                <a-form-item label="标题" v-bind="layoutStyle2">
                    <a-input v-decorator="['name']"/>
                </a-form-item>
                <a-form-item label="状态" v-bind="layoutStyle2">
                    <a-select v-decorator="['auditingFlag']" >
                        <a-select-option value=''>
                            全部
                        </a-select-option>
                        <a-select-option value='-1'>
                            退回
                        </a-select-option>
                        <a-select-option value='00'>
                            保存
                        </a-select-option>
                        <a-select-option value='11'>
                            待审核
                        </a-select-option>
                        <a-select-option value='13'>
                            已发布
                        </a-select-option>
                    </a-select>
                </a-form-item>
            </a-form>
        </div>
        <div class="btns-group">
            <a-button type="primary" @click="handleSearch">
                搜索
            </a-button>
            <a-button @click="handleReset">
                重置
            </a-button>
            <a-button @click="writeArticle" type="primary">
                发布文章
            </a-button>
        </div>

        <a-table
                class="account-list"
                :columns="colunms"
                :dataSource="articleList"
                @change="handleTableChange"
                bordered
                rowKey="id"
                :pagination="pagination"
        >
            <template slot="titleName" slot-scope="text,record">
                <a @click="() => show(record.infoId)"
                >{{text}}</a
                >
            </template>
            <template slot="auditingFlag" slot-scope="text, record">
                {{ text=='-1' ? "退回" : text=='00' ? "保存" :text=='11' ? "待审核" :text=='13' ? "已发布" :"" }}
            </template>
            <template slot="operation" slot-scope="text, record">
                <div class="editable-row-operations">
                    <a @click="() => update(record.infoId)" v-if="record.auditingFlag=='-1'||record.auditingFlag=='00'">修改</a>

                    <a @click="() => deleteArticle(record.infoId)" v-if="record.auditingFlag=='-1'||record.auditingFlag=='00'">删除</a>


                </div>
            </template>
        </a-table>
        <a-drawer
                title="添加信息"
                destroyOnClose
                width="100%"
                @close="onClose"
                :visible="editVisable"
                :wrapStyle="{ height: 'calc(100% - 108px)', overflow: 'auto' }"
        >
            <a-form :form="form">
                <a-row>
                    <a-col :span="12">
                        <a-form-item label="标题" v-bind="editTitleLayoutStyle">
                            <a-input
                                    v-decorator="[
                                    'title',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请填写标题'
                                            }
                                        ]
                                    }

                                ]"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="发布时间" v-bind="editTitleLayoutStyle">
                            <a-date-picker
                                           v-decorator="[
                                    'publishDate',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请选择发布时间'
                                            }
                                        ]
                                    }
                                    ]
              "/>
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="12">
                        <a-form-item label="信息来源" v-bind="editAuthorLayoutStyle">
                            <a-input
                                    v-decorator="[
                                    'source',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请填写信息来源'
                                            }
                                        ]
                                    }

                                ]"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="信息作者" v-bind="editAuthorLayoutStyle">
                            <a-input
                                    v-decorator="[
                                    'author',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请填写信息作者'
                                            }
                                        ]
                                    }

                                ]"
                            />
                        </a-form-item>
                    </a-col>


                <a-col :span="12" >
                <a-form-item label="选择栏目" v-bind="editAuthorLayoutStyle">
                    <a-select
                            placeholder="选择栏目"
                            v-decorator="[
                                        'topicId',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: '请选择栏目'
                                                }
                                            ]
                                        }
                                    ]"
                    >
                        <a-select-option
                                v-for="item in selectOptions"
                                :key="item.topicId"
                                :value="item.topicId"
                                :title="item.topicId"
                        >{{item.topicName}}</a-select-option>
                    </a-select>
                </a-form-item>
                </a-col>
                </a-row>


                <div id="editor">

                </div>
                <a-row>
                    <a-col :span="12">
                        <a-form-item label="附件" v-bind="editTitleLayoutStyle">
                            <a-upload
                                    v-decorator="[
          'qtfj',
          {

          },
        ]"
                                    name="file"
                                    action="/creditapi/info/upload"
                                    list-type="text"
                                    :file-list="qtfjList"
                                    @change="filechange3"
                            >
                                <a-button> <a-icon type="upload" /> 点击上传</a-button>
                            </a-upload>
                        </a-form-item>
                    </a-col>
                </a-row>
                <div class="submit-btn">
                    <a-button @click="saveArticleBtn('00')" type="primary"
                    >保存
                    </a-button
                    >&nbsp;
                    <a-button @click="saveArticleBtn('11')" type="primary"
                    >提交
                    </a-button
                    >&nbsp;
                    <a-button @click="onClose" type="primary"
                    >关闭
                    </a-button
                    >

                </div>
            </a-form>

        </a-drawer>
        <a-drawer
                title="文章详情"
                destroyOnClose
                width="1000px"
                @close="onClose"
                :visible="readVisable"
                :wrapStyle="{ height: 'calc(100% - 108px)', overflow: 'auto',backgroudcolor: '#333' }"
        >

            <div id="title" style="margin-bottom: 3px;">
                <h1 style="text-align: center;"><span style="font-size: xx-large;" v-html="readTitle"></span></h1>
            </div>
            <div id="author" style="margin-bottom: 7px;">
                <p style="text-align: center;">信息来源：<span style="font-size: small;" v-html="readAuthor"></span> &nbsp;&nbsp;&nbsp;&nbsp;发布时间：<span v-html="readCreateTime"></span></p>
            </div>
            <div style="width: 100%;margin-left: auto;margin-right: auto;">
                <p>
                    <span v-html="readContent"></span>
                </p>
                <p v-if="ids.length>0" style="margin-top: 10px;">
                    附件：
                    <div v-for="(item,index) in ids">
                <a :href="'http://credit.hunan.gov.cn/uploadFile/'+item" target="_blank">{{names[index]}}</a>
            </div>
                </p>
            </div>

        </a-drawer>
        <a-modal
                v-model="comform"
                title="删除确认"
                okText="确认"
                cancelText="取消"
                @ok="handleOk"
        >
            <p>确定删除该信息？</p>
        </a-modal>
    </div>

</template>

<script>
    import Editor from 'wangeditor'
    import moment from 'moment';
    import {search, saveArticle, findById, deleteArticle,updateArticle,getSelectAjax} from "@/api/info/info"

    const colunms = [
        {
            title: "标题",
            dataIndex: "title",
            scopedSlots: {customRender: "titleName"}
        },
        {
            title: "作者",
            dataIndex: "author",
            scopedSlots: {customRender: "author"}
        },
        {
            title: "来源",
            dataIndex: "source",
            scopedSlots: {customRender: "source"}
        },
        {
            title: "发布日期",
            dataIndex: "publishDate",
            scopedSlots: {customRender: "publishDate"}
        },
        {
            title: "采编用户",
            dataIndex: "userName",
            scopedSlots: {customRender: "userName"}
        },
        {
            title: "采编部门",
            dataIndex: "orgName",
            scopedSlots: {customRender: "orgName"}
        },
        {
            title: "采编日期",
            dataIndex: "inputDate",
            scopedSlots: {customRender: "inputDate"}
        },

        {
            title: "状态",
            dataIndex: "auditingFlag",
            scopedSlots: {customRender: "auditingFlag"}
        },
        {
            title: "操作",
            dataIndex: "operation",
            scopedSlots: {customRender: "operation"}
        }
    ];
    export default {
        name: "article",
        data() {
            return {
                modalTitle: "",
                modalVisible: false,
                modalImg: "",
                uploadImgUrl: "",
                coverImgVisable: false,
                comform :false,
                delId : "",
                imageUrl: "",
                readCreateTime: "",
                readTitle: "",
                readAuthor: "",
                readContent: "",
                form: this.$form.createForm(this),
                editId: "",
                editContent: "",
                editorFlag: 0,
                editVisable: false,
                readVisable: false,
                updateVisable: false,
                formSearch: this.$form.createForm(this),
                qtfjList:[],
                colunms,
                pagination: {
                    total: 0,
                    current: 1,
                    pageNum: 1,
                    pageSize: 15,
                    name: "",
                    auditingFlag: ""
                },
                layoutStyle: {
                    labelCol: {
                        span: 7
                    },
                    wrapperCol: {
                        span: 16
                    }
                },
                editTitleLayoutStyle: {
                    labelCol: {
                        span: 3
                    },
                    wrapperCol: {
                        span: 15
                    }
                },
                editAuthorLayoutStyle: {
                    labelCol: {
                        span: 3
                    },
                    wrapperCol: {
                        span: 10
                    }
                },
                layoutStyle2: {
                    labelCol: {
                        span: 7
                    },
                    wrapperCol: {
                        span: 17
                    }
                },
                articleList: [],
                ids: [],
                names: [],
                selectOptions:[],
                editor: ''
            }
        },
        mounted() {
            getSelectAjax()
                .then((res) => {
                    this.$ajaxAfter(res).then(() => {
                        this.selectOptions = res.data.data.selectOptions;
                    });
                })
                .catch(() => {
                    this.$message.error("服务器系统错误，请稍后重试！");
                });
            // this.initEditor();
            // this.initEditor();
        },

        beforeRouteEnter(to, from, next) {
            search({})
                .then(res => {
                    next(vm => {
                        vm.$ajaxAfter(res).then(() => {
                            if (res.data.success == "FALSE") {
                                vm.$message.error(res.data.message);
                            } else {
                                vm.articleList = res.data.data.page.list;
                                Object.assign(vm.pagination, {
                                    total: res.data.data.page.total,
                                    pageSize: res.data.data.page.pageSize,
                                    current: res.data.data.page.pageNum
                                });
                            }
                        })
                    })
                })
                .catch(() => {
                    next(vm => {
                        vm.$message.error("服务器出错！请稍后再试!");
                    })
                });
        },
        methods: {

            async initEditor(content) {
                this.editor = new Editor('#editor') /* 括号里面的对应的是html里div的id */
                /* 配置菜单栏 */
                this.editor.customConfig.menus = [
                    'head',  // 标题
                    'bold',  // 粗体
                    'fontSize',  // 字号
                    'fontName',  // 字体
                    'italic',  // 斜体
                    'underline',  // 下划线
                    'strikeThrough',  // 删除线
                    'foreColor',  // 文字颜色
                    'list',  // 列表
                    'justify',  // 对齐方式
                    'quote',  // 引用
                    'table',  // 表格
                    'undo',  // 撤销
                ]
                this.editor.customConfig.uploadImgMaxLength = 5 /* 限制一次最多上传 5 张图片 */
                this.editor.customConfig.uploadImgMaxSize = 10 * 1024 * 1024 /* 将图片大小限制为 3M 默认为5M /
        /* 自定义图片上传（支持跨域和非跨域上传，简单操作）*/
                this.editor.customConfig.customUploadImg = async (files, insert) => {
                    /* files 是 input 中选中的文件列表 */
                    let formData = new FormData()
                    formData.append('file', files[0])
                    let data = await this.uploadImg(formData);
                    // let data = await this.upload(formData)
                    /* upload方法是后台提供的上传图片的接口 */
                    /* insert 是编辑器自带的 获取图片 url 后，插入到编辑器的方法 上传代码返回结果之后，将图片插入到编辑器中*/
                    insert("/img/" + data.data.data.value);
                }
                this.editor.customConfig.onchange = (html) => {
                    this.editContent = html;
                }
                this.editor.create() /* 创建编辑器 */
                content = content + "";
                this.editor.txt.html(content);
            },
            //下一页
            handleTableChange(page) {
                this.pagination.pageNum = page.current;
                this.initArticle();
            },
            initArticle() {
                search(this.pagination)
                    .then(res => {
                        this.$ajaxAfter(res).then(() => {
                            if (res.data.success == "FALSE") {
                                this.$message.error(res.data.message);
                                return;
                            }

                            this.articleList = res.data.data.page.list;
                            Object.assign(this.pagination, {
                                total: res.data.data.page.total,
                                pageSize: res.data.data.page.pageSize,
                                current: res.data.data.page.pageNum
                            });
                        })
                    })
                    .catch(() => {
                        this.$message.error("服务器出错！请稍后再试!");
                    });
            },

            onClose() {
                this.editVisable = false;
                this.updateVisable = false;
                this.readVisable = false;
                this.editId = -1;
                this.imageUrl = "";
                this.coverImgVisable = false;
                this.qtfjList=[];
            },
            writeArticle() {
                this.editVisable = true;
                this.$nextTick(() => {
                    this.initEditor("");
                })
            },
            saveArticleBtn(auditingFlag) {
                let values = this.form.getFieldsValue();
                values.infoId = this.editId;
                values.content = this.editContent;
                values.auditingFlag = auditingFlag;
                values.publishDate=moment(values.publishDate).format('YYYY-MM-DD');
                let qtfj="";
                let fjname="";
                for (let i = 0; i < this.qtfjList.length; i++) {
                    fjname+=this.qtfjList[i].name+"|";
                    qtfj+=this.qtfjList[i].response.data.id+"|";
                }
                values.accessoryIds = qtfj;
                values.accessoryNames = fjname;
                if(this.editId!=null&&this.editId!=''){
                    updateArticle(values).then(res => {
                        this.$ajaxAfter(res).then(() => {
                            let message = "";
                            if (res.data.success == "TRUE") {
                                if (auditingFlag == '11') {
                                    message = "提交成功！";
                                } else {
                                    message = "保存成功！";
                                }
                                this.$message.success(message);
                                this.editVisable = false;
                                this.initArticle();
                            } else {
                                this.$message.error("操作失败，请联系管理员！");
                            }
                        })
                    })
                        .catch(() => {
                            this.$message.error("服务器出错！请稍后再试!");
                        });
                }else{
                    saveArticle(values).then(res => {
                        this.$ajaxAfter(res).then(() => {
                            let message = "";
                            if (res.data.success == "TRUE") {
                                if (auditingFlag == '11') {
                                    message = "提交成功！";
                                } else {
                                    message = "保存成功！";
                                }
                                this.$message.success(message);
                                this.editVisable = false;
                                this.initArticle();
                            } else {
                                this.$message.error("操作失败，请联系管理员！");
                            }
                        })
                    })
                        .catch(() => {
                            this.$message.error("服务器出错！请稍后再试!");
                        });
                }

            },

            handleSearch() {
                let values = this.formSearch.getFieldsValue();
                this.pagination.name = values.name;
                this.pagination.auditingFlag = values.auditingFlag;
                this.pagination.pageNum = 1;
                this.initArticle();
            },
            handleReset() {
                this.pagination.name = null;
                this.pagination.auditingFlag = '';
                this.pagination.pageNum = 1;

                this.initArticle();
            },
            update(id) {
                findById(id).then(res => {
                    this.$ajaxAfter(res).then(() => {
                        if (res.data.success == "TRUE") {
                            this.editId = id;
                            this.editVisable = true;
                            setTimeout(() => {
                                this.form.setFieldsValue({
                                    title: res.data.data.info.title,
                                    author: res.data.data.info.author,
                                    topicId:res.data.data.info.topicId,
                                    publishDate: moment(res.data.data.info.publishDate,'YYYY-MM-DD'),
                                    source: res.data.data.info.source
                                });
                            }, 0);
                            this.ids=[];
                            this.names=[];
                            this.qtfjList=[];
                            if(res.data.data.info.accessoryIds)
                                this.ids=res.data.data.info.accessoryIds.split('|');
                            if(res.data.data.info.accessoryNames)
                                this.names=res.data.data.info.accessoryNames.split('|');
                            for(let i=0;i<this.ids.length;i++){
                                if(this.ids[i]!='') {
                                    let file = {
                                        uid: i,
                                        name: this.names[i],
                                        status: 'done',
                                        response: {
                                            data: {
                                                id: this.ids[i]
                                            }
                                        }
                                    }
                                    this.qtfjList.push(file);
                                }
                            }
                            this.$nextTick(() => {
                                this.initEditor(res.data.data.infoContent.content);
                            })
                        } else {
                            this.$message.error(res.data.message);
                        }
                    })
                }).catch(() => {
                    this.$message.error("服务器出错！请稍后再试!");
                });
            },
            deleteArticle(id) {
                this.comform = true;
                this.delId = id;
            },
            handleOk() {
                deleteArticle(this.delId).then(res => {
                    this.$ajaxAfter(res).then(() => {
                        if (res.data.success == "TRUE") {
                            this.$message.success("删除成功");
                        } else {
                            this.$message.error("ERROR");
                        }
                        this.initArticle();
                    })
                }).catch(() => {
                    this.$message.error("服务器出错！请稍后再试!");
                });
                this.delId = "";
                this.comform = false;
            },
            show(id) {
                findById(id).then(res => {
                    this.$ajaxAfter(res).then(() => {
                        if (res.data.success == "TRUE") {
                            this.readVisable = true;
                            this.readTitle = res.data.data.info.title;
                            this.readAuthor = res.data.data.info.source;
                            this.readContent = res.data.data.infoContent.content;
                            this.readCreateTime = res.data.data.info.publishDate;
                            this.ids=[];
                            this.names=[];
                            if(res.data.data.info.accessoryIds)
                            this.ids=res.data.data.info.accessoryIds.split('|');
                            if(res.data.data.info.accessoryNames)
                            this.names=res.data.data.info.accessoryNames.split('|');

                        } else {
                            this.$message.error(res.data.message);
                        }
                    })
                }).catch(() => {
                    this.$message.error("服务器出错！请稍后再试!");
                });
            },
            filechange3({file,fileList}){
                this.qtfjList=fileList;
                if(file.status=='done'){
                    console.log(file);
                    if(file.response.success == 'FALSE'){
                        this.$message.error(file.response.message);
                    }else{
                    }
                }
            },
            closeModal() {
                this.modalVisible = false;
            },
        }
    }
</script>

<style scoped>
    #editor {
        height: 340px;
    }

    .wangEditor-container {
        border-radius: 2px;
        overflow: hidden;
        border: 1px solid #CCC;
    }
</style>
<style>
    .search-box .ant-form-item-label {
        width: 60px;
        text-align: left;
    }
</style>
<style scoped lang="less">
    .f14 {
        font-size: 14px;
    }

    .search-box {
        .ant-form-item {
            display: inline-block;
            min-width: 280px;
        }

        .ant-select {
            width: 100%;
        }
    }
    .btns-group{
        text-align: center;
    }
    .btns-group button {
        margin-right: 10px;
    }

    .submit-btn {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        border-top: 1px solid #e9e9e9;
        padding: 10px 16px;
        background: #fff;
        text-align: right;
    }

    .ant-row > div {
        height: 63px;
    }

    .account-list {
        margin-top: 30px;
    }

    .editable-row-operations a {
        margin-right: 10px;
    }

    .account-info {
        margin-bottom: 10px;
    }

    .auto-label {
        font-size: 14px;
    }

    .auth-list {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #e8e8e8;
        padding: 10px 0;
    }

    .menu-top {
        flex-shrink: 0;
        width: 120px;
    }

    .menu-two-item {
        margin: 10px 0;
    }

    .menu-two-item {
        margin: 10px 0;
        display: flex;
        align-items: center;
    }

    .menu-two-top {
        width: 110px;
        flex-shrink: 0;
    }

    .operation-item {
        line-height: 28px;
    }
</style>
